import { createStore } from 'vuex';
import flowsDetails from '@/store/flow-details';
import integrationDetails from '@/store/integration-details';
import sidebar from '@/store/sidebar';

export default new createStore({
  modules: {
    flowsDetails,
    integrationDetails,
    sidebar,
  },
});
